module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Medium.d6b80628.eot";